import React, { useState } from 'react';
import { apiFetch } from './utils/api';
import PageHeader from './components/PageHeader';

function RamsSettingsPage() {
  const [setupLoading, setSetupLoading] = useState(false);
  const [setupResult, setSetupResult] = useState(null);

  const runSetup = async () => {
    if (!window.confirm('Run RAMS table setup? This will create any missing tables. Safe to run multiple times.')) return;
    setSetupLoading(true);
    setSetupResult(null);
    try {
      const res = await apiFetch('/api/setup/rams-tables', { method: 'POST' });
      const data = await res.json();
      setSetupResult(data);
    } catch (err) {
      setSetupResult({ error: err.message });
    }
    setSetupLoading(false);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <PageHeader
        title="RAMS Settings"
        subtitle="Database setup and configuration"
        backTo="/rams"
        backLabel="RAMS"
        sticky
      />

      <main className="max-w-4xl mx-auto px-6 py-8">
        <div className="bg-white rounded-lg shadow p-6 mb-6 border border-gray-200">
          <h2 className="text-lg font-semibold text-gray-800 mb-3">Database Setup</h2>
          <p className="text-sm text-gray-600 mb-4">
            Creates all RAMS tables if they don't exist. Safe to run multiple times (idempotent).
            Tables: rams_documents, rams_scope_items, rams_risks, rams_method_steps, rams_ppe, rams_equipment, rams_materials, rams_templates.
          </p>
          <button
            onClick={runSetup}
            disabled={setupLoading}
            className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700 disabled:opacity-50 text-sm font-semibold"
          >
            {setupLoading ? 'Running...' : 'Run Table Setup'}
          </button>
          {setupResult && (
            <div className="mt-3 text-sm">
              {setupResult.error ? (
                <span className="text-red-600">Error: {setupResult.error}</span>
              ) : (
                <span className="text-green-600">✓ {setupResult.message || 'Setup complete'}</span>
              )}
            </div>
          )}
        </div>

        <div className="bg-white rounded-lg shadow p-6 border border-gray-200">
          <h2 className="text-lg font-semibold text-gray-800 mb-3">Template Management</h2>
          <p className="text-sm text-gray-600 mb-4">
            Templates are managed in the Templates page. Use the seed buttons there to add the base (6) and extended (12) template sets.
          </p>
          <a
            href="/rams/templates"
            className="inline-block px-4 py-2 bg-orange-600 text-white rounded hover:bg-orange-700 text-sm font-semibold no-underline"
          >
            Go to Templates →
          </a>
        </div>
      </main>
    </div>
  );
}

export default RamsSettingsPage;
